import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5e31d70e"
import script from "./view.ts?vue&type=script&lang=js&external"
export * from "./view.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e31d70e')) {
      api.createRecord('5e31d70e', component.options)
    } else {
      api.reload('5e31d70e', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=5e31d70e", function () {
      api.rerender('5e31d70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/gradePCP/view.vue"
export default component.exports